import React, { Fragment, useState, useEffect } from "react";
import {
    Button,
    makeStyles,
    Grid,
    Divider,
    Backdrop,
    CircularProgress
} from "@material-ui/core";
//componentes del sistema
import { palette, useStylesGlobal } from "configurations/styles/theme";
import middleware from "configurations/axios";
import apis from "./apis";

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(0),
        minWidth: 120,
    },
    radio: {
        display: "-webkit-box",
        marginTop: "0px",
    },
    radioLable: {
        color: palette.primary.main,
        display: "flex",
    },
    radioButton: {
        marginTop: "0px",
        paddingTop: "0px",
    },
    divForm: {
        marginBottom: "1%",
    },
    divInput: {
        marginBottom: "1%",
        paddingRight: "1%",
        paddingLeft: "0.5%",
    },
    divButton: {
        paddingLeft: "3%",
        paddingRight: "3%",
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
}));

const QrSecurityCode = ({ data, onShowAlert, handleCloseReload = () => { } }) => {
    const classes = useStyles();
    const classesGlobal = useStylesGlobal();
    const [company, setCompany] = useState(data);
    const [objValores, setObjValores] = useState({})
    const [openLoader, setOpenLoader] = useState(false);
    const [stateQr, setStateQr] = useState("");
    const [itipSol, setItipSol] = useState(0);
    useEffect(() => { getObject(data); }, []);
    useEffect(() => {
        if (company.estadoCodigoSeguridadQr == 1) {
            setStateQr("Generado")
        }
        if (company.estadoCodigoSeguridadQr == 2) {
            setStateQr("Anulado")
        }
        if (company.estadoCodigoSeguridadQr == 3) {
            setStateQr("Pendiente")
        }
        if (company.estadoCodigoSeguridadQr == 4) {
            setStateQr("A espera de comunicación con la DGI")
        }
    }, [company]);

    useEffect(() => {
        if (itipSol != 0) {
            handleGenerate()
        }
    }, [itipSol]);

    const getObject = (obj) => {
        setObjValores(obj)
    }

    const handleGenerate = async () => {
        setOpenLoader(true);
        await middleware.post(apis.update_qr_security_code + "/" + itipSol, company).then(
            response => {
                if (response.status >= 200 && response.status <= 300) {
                    if (response.data === 1 || response.data === 2) {
                        onShowAlert({ show: true, msg: 'La solicitud del código de seguridad QR se ha realizado con éxito.', type: "success" });
                        //*
                        setCompany({ ...company, estadoCodigoSeguridadQr: itipSol })
                    } else if (response.data === 3) {
                        onShowAlert({ show: true, msg: 'La solicitud del código de seguridad QR esta pendiente. Por favor, realizar esta acción mas tarde.', type: "warning" });
                    }
                }
                handleCloseReload()
                setOpenLoader(false);
            }
        ).catch(
            exception => {
                if (exception.response) {
                    if (exception.response.status === 400) {
                        onShowAlert({ show: true, msg: 'No se pudo realizar la solicitud del código de seguridad QR.', type: "error" });
                    }
                } else {
                    onShowAlert({ show: true, msg: 'Existen problemas en la red. Contáctese con el administrador del Sistema.', type: "error" });
                }
                setOpenLoader(false);

            }
        );
    }

    return (
        <Fragment>
            <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="center"
            >
                <Grid item md={12} xs={12}>
                </Grid>
                <Grid container spacing={3} justify="center">
                    <Grid item md={4} xs={12}>
                        <label>
                            ESTADO CÓDIGO SEGURIDAD QR:{" "}
                            <font color={palette.error.main}>*</font>
                        </label>
                    </Grid>

                    <Grid item md={4} xs={12} className={classes.divInput}>
                        <input class="form-control" disabled
                            value={stateQr}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={3} justify="center">
                    <Grid item md={12} xs={12}>
                        <Divider></Divider>
                    </Grid>
                    <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        disabled={(company.estadoCodigoSeguridadQr == 1 || company.estadoAfiliacionPac == 3 || company.estadoAfiliacionPac == 4) ? true : false}
                        onClick={() => setItipSol(1)}
                        className={classesGlobal.marginButton}
                    >
                        Generar código de seguridad QR
                    </Button>
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={() => setItipSol(2)}
                        disabled={(company.estadoCodigoSeguridadQr == 2 || company.estadoAfiliacionPac == 3 || company.estadoAfiliacionPac == 4) ? true : false}
                        className={classesGlobal.marginButton}
                    >
                        Anular código de seguridad QR
                    </Button>
                </Grid>
            </Grid>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Fragment>
    );
};

export default QrSecurityCode;
